<template>
  <div id="product-list" class="row">
    <template v-for="(product, key) in pagination.items">
      <div v-if="key == adPosition" :key="`ad-${product.id}`" class="col-lg-3 col-md-4 col-sm-6 col-xs-6 mb-4">
        <advert-card :advert="pagination.advert"></advert-card>
      </div>
      <div :key="product.id" class="col-lg-3 col-md-4 col-sm-6 col-xs-6 mb-4">
        <product-card :product="product"></product-card>
      </div>
    </template>
    <div class="col" v-if="pagination.items.length === 0">
      <h2 class="text-center"><em>{{$t('category.no_results')}}</em></h2>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ProductCard from './ProductCard'
import AdvertCard from './AdvertCard'

const { mapState, mapGetters } = createNamespacedHelpers('filters')

export default {
  components: { ProductCard, AdvertCard },
  computed: {
    ...mapState(['pagination', 'adPosition']),
    ...mapGetters(['adPosition'])
  }
}
</script>
